'use strict';

var enhancedMapping = require('./enhancedMapping'),
    wrapNativeArrayMethod = require('./wrapNativeArrayMethod');

function buildEnhancedMapping(name) {
  return wrapNativeArrayMethod(name, enhancedMapping);
}

module.exports = buildEnhancedMapping;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/enumerable/internal/buildEnhancedMapping.js
// module id = 620
// module chunks = 0